import "./index.scss";
import LoginPageLyout from "@layouts/login";
import { useState, useRef, useEffect } from "react";
import {
  adminLogin,
  authSSOLogin,
  getCapchaByID,
  GetSpecificOrganizationToken,
} from "@services/auth.service";
import { getValue } from "@utils/lodash";
import SimpleReactValidator from "simple-react-validator";
import InputField from "@_common/InputRuleFeild";
import { useNavigate } from "react-router-dom";
import { nanoid } from "nanoid";
import { toast } from "react-toastify";
import { aesGcmEncrypt, getHmac } from "@_common/text-helpers";
import { config } from "../../../../env";
import { QueryRequestHelper } from "@_common/query-request-helper";
import RefreshSvgComponent from "../../../../assets/svg-components/refresh";
import {
  getAllPermissions,
  getAllPermissionsWithToken,
} from "@services/roles.service";
import _ from "lodash";
import { allNavigationMenu } from "@components/common/LeftNavbar/PermissionJSON";
import { sanitizeInput } from "@_common/dompurify";
interface ILoginPageProps {}

const LoginPage: React.FunctionComponent<ILoginPageProps> = (props: any) => {
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user_type] = useState("CLIENT");
  const [rid, setRid] = useState("");
  const [captcha_enable, setCaptcha_enable] = useState(false);
  const [captcha_text, setCaptcha_text] = useState("");

  useEffect(() => {
    getSSOLoginInfo();
    let rid: any = nanoid();
    setRid(rid);
    //
    let count: any = getValue(localStorage, `cn`, "")
      ? parseInt(getValue(localStorage, `cn`, ""))
      : 0;
    if (count === 3 || count > 2) {
      setCaptcha_enable(true);
      getCapcha(rid);
    }
  }, []);

  const [capchaImage, setCapchaImage] = useState("");
  const getCapcha = async (id: string) => {
    try {
      let payload = {
        rid: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getCapchaByID(queryRequest);
      if (resp) {
        setCapchaImage(getValue(resp, `data.captcha_image`, ""));
      }
    } catch (error) {}
  };
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      localStorage.setItem("hash", rid);
      let pass = await aesGcmEncrypt(password);
      let emailEncrypted = await aesGcmEncrypt(email.toLowerCase());
      let hashedRid = await getHash(localStorage.getItem("hash"));
      try {
        setIsLoading(true);
        let payload: any = {
          email: emailEncrypted,
          encrypted_password: pass,
          user_type: user_type,
          rid: rid,
          captcha_text: captcha_text,
        };
        Object.keys(payload).forEach((key) => {
          if (!payload[key] || payload[key] === undefined) {
            delete payload[key];
          }
        });
        let resp = await adminLogin(payload);
        if (resp) {
          if (getValue(resp, `data.mfa_required`, false)) {
            setIsLoading(false);
            navigate(`/login-otp/${getValue(resp, `data.mfa_token`, "")}`);
          } else {
            if (getValue(resp, `data.rid_hash`, "") !== hashedRid) {
              localStorage.removeItem("hash");
              toast.error("Oops! Please try again later.");
              setIsLoading(false);
            } else {
              let getPermissions = await getAllPermissionsWithToken(
                getValue(resp, `data.accessToken`, "")
              );
              let response = getValue(
                getPermissions,
                `data.permissions`,
                []
              ).filter((item: any) => {
                if (item) return item;
              });
              let subTabPermissions = handlePermissionLogic(response);
              let link = optimizeNavigationMenus(
                getValue(subTabPermissions, `tabs`, []),
                getValue(subTabPermissions, `subTabs`, [])
              );
              localStorage.removeItem("cn");
              setIsLoading(false);
              localStorage.setItem(
                "accessToken",
                getValue(resp, `data.accessToken`, "")
              );
              localStorage.setItem(
                "refreshToken",
                getValue(resp, `data.refreshToken`, "")
              );
              localStorage.setItem("op", getValue(resp, `data.op`, ""));
              localStorage.setItem(
                "user",
                JSON.stringify(getValue(resp, `data.user`, ""))
              );
              window.location.href = `${link}`;
              localStorage.removeItem("hash");
              if (getValue(resp, `data.user.org_id`, "")) {
                getData(
                  getValue(resp, `data.user.org_id`, ""),
                  getValue(resp, `data.accessToken`, "")
                );
              }
            }
          }
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        let rid: any = nanoid();
        setRid(rid);
        let count: any = getValue(localStorage, `cn`, "")
          ? parseInt(getValue(localStorage, `cn`, ""))
          : 0;
        localStorage.setItem("cn", count ? count + 1 : 1);
        if (count === 2 || count > 2) {
          setCaptcha_enable(true);
          getCapcha(rid);
        }
        setIsLoading(false);
      }
    }
  };
  const getData = async (id: string, token: string) => {
    try {
      let resp = await GetSpecificOrganizationToken(id, token);
      if (resp) {
        let logo = getValue(resp, `data.data.organisation_logo`, "")
          ? getValue(resp, `data.data.organisation_logo`, "")
          : getValue(resp, `data.organisation_logo`, "");
        localStorage.setItem("organisation_logo", logo);
      }
    } catch (error) {}
  };
  const handleKeyDown = (e: any) => {
    if (e.key === "Enter" && e.target.tagName.toLowerCase() !== "button") {
      e.preventDefault();
      handleSubmit(e);
    }
  };
  const covertSecondString = (s: string) => {
    var lastIndex = s.lastIndexOf(":");
    if (lastIndex !== -1) {
      s = s.substring(0, lastIndex) + "-" + s.substring(lastIndex + 1);
    }
    return s;
  };
  const handlePermissionLogic = (response: any) => {
    let list =
      getValue(response, `length`, 0) > 0
        ? response.map((item: any) => {
            return covertSecondString(item).split("-").length === 2
              ? covertSecondString(item).split("-")
              : item.split(":");
          })
        : [];

    let arr: any = [];
    for (let i = 0; i < list.length; i++) {
      arr.push({
        tab: list[i][0],
        permission: list[i][1],
      });
    }
    var groupedPermission =
      getValue(arr, `length`, 0) > 0
        ? _.groupBy(arr, function (item: any) {
            return item.tab;
          })
        : [];
    var ObjectEntry: any = Object.entries(groupedPermission);
    const arr1: any = [];
    for (let i = 0; i < ObjectEntry.length; i++) {
      arr1.push({
        tab: ObjectEntry[i][0].split(":")[0],
        tabKey:
          ObjectEntry[i][0].split(":").length == 2
            ? ObjectEntry[i][0].split(":")[0] +
              "_" +
              ObjectEntry[i][0].split(":")[1]
            : ObjectEntry[i][0].split(":").length == 3
            ? ObjectEntry[i][0].split(":")[0] +
              "_" +
              ObjectEntry[i][0].split(":")[1] +
              "_" +
              ObjectEntry[i][0].split(":")[2]
            : ObjectEntry[i][0].split(":")[0],
        permissions: ObjectEntry[i][1].map((item: any) => item.permission),
      });
    }
    let tabs = _.uniq(arr1.map((item: any) => item.tab));
    let subTabs = _.uniq(arr1.map((item: any) => item.tabKey));
    return { tabs, subTabs };
  };

  function optimizeNavigationMenus(
    permissions: string[],
    subTabPermissionList: string[]
  ): any {
    let mainMenu: any =
      getValue(allNavigationMenu, `length`, 0) > 0 &&
      allNavigationMenu.filter((item: any) =>
        permissions.includes(getValue(item, `name`, ""))
      );
    let checkChildrensPermission =
      getValue(mainMenu, `length`, 0) > 0 &&
      mainMenu.map((menuItem: object) => {
        let menus =
          getValue(menuItem, `menu.length`, 0) > 0 &&
          getValue(menuItem, `menu`, []).map((item: object) => {
            let childrens =
              getValue(item, `childrens.length`, 0) > 0 &&
              getValue(item, `childrens`, []).filter((child: object) =>
                subTabPermissionList.includes(getValue(child, `name`, ""))
              );
            if (getValue(item, `childrens.length`, 0) > 0) {
              return {
                ...item,
                childLink: getValue(childrens, `[${0}].link`, ""),
                name: getValue(childrens, `[${0}].name`, ""),
                childrens: childrens,
              };
            } else {
              return {
                ...item,
                childLink: getValue(item, `link`, ""),
              };
            }
          });
        return {
          ...menuItem,
          menu: menus,
        };
      });

    let checkMenuPermission =
      getValue(checkChildrensPermission, `length`, 0) > 0 &&
      checkChildrensPermission.map((menuItem: object) => {
        let menus =
          getValue(menuItem, `menu.length`, 0) > 0
            ? getValue(menuItem, `menu`, []).filter((item: object) =>
                subTabPermissionList.includes(getValue(item, `name`, ""))
              )
            : [];

        return {
          ...menuItem,
          menu: menus,
        };
      });
    return getValue(checkMenuPermission, `[${0}].menu[${0}].childLink`, "");
    // return getValue(checkMenuPermission, `length`, 0) > 0
    //   ? checkMenuPermission.map((item: object) => ({
    //       ...item,
    //       childLink: getValue(item, `menu[${0}].childLink`, ""),
    //     }))
    //   : [];
  }

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const getHash = async (id: any) => {
    return await getHmac(id, config.AUTH_SHARED_KEY);
  };

  const [ssoURL, setSsoURL] = useState("");
  const getSSOLoginInfo = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const isAutoSso = params.get('autologin') === 'sso';
      let resp = await authSSOLogin("");
      if (resp) {
        setSsoURL(getValue(resp, `data`, ""));
      }
      if (isAutoSso && getValue(resp, `data`, "")) {
        window.location.href = getValue(resp, `data`, "");
      }
    } catch (error) {}
  };
  const handleSSOLogin = async () => {
    // try {
    //   let resp = await authSSOLogin("");
    //   if (resp) {
    window.location.href = ssoURL;
    //   }
    // } catch (error) {}
  };
  return (
    <>
      <LoginPageLyout>
        <div className="m-auto form-wrapper__form">
          <form
            // onSubmit={(e: any) => {
            //   e.preventDefault();
            //   handleSubmit(e);
            // }}
            autoComplete="on"
          >
            <h2 className="mb-3">Sign in to Lexcare</h2>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <InputField
                inputType="EMAIL"
                id="email"
                name="email"
                value={email}
                onChange={(e: any) => setEmail(sanitizeInput(e.target.value))}
                placeholder="Enter Email"
                className="form-control"
                label="Email"
                validator={simpleValidator}
                onKeyDown={handleKeyDown}
                autoComplete="on"
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <InputField
                inputType="PASSWORD"
                id="password"
                name="password"
                value={password}
                onChange={(e: any) => setPassword(e.target.value)}
                placeholder="Enter Password"
                className="form-control"
                validator={simpleValidator}
                label={"Password"}
                onKeyDown={handleKeyDown}
                autoComplete="on"
              />
            </div>
            {captcha_enable && capchaImage && (
              <div>
                <div className=" position-relative">
                  <div
                    dangerouslySetInnerHTML={{ __html: capchaImage }}
                    className="captcha_container"
                  />
                  <div
                    className="captcha_reload"
                    onClick={() => getCapcha(rid)}
                  >
                    <RefreshSvgComponent />
                  </div>
                </div>
                <input
                  type="text"
                  className="captcha_input"
                  name={"captcha_text"}
                  value={captcha_text}
                  onChange={(e: any) =>
                    setCaptcha_text(sanitizeInput(e.target.value))
                  }
                  placeholder="Enter Captcha"
                />
              </div>
            )}
            <div className="form-cta-button">
              <div>
                <button
                  className="form-cta-button__secondary-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/auth/client/forgot-password`);
                  }}
                >
                  Forgot password?
                </button>
              </div>
              {isLoading ? (
                <button className="form-cta-button__primary-btn">
                  Please wait...
                </button>
              ) : (
                <button
                  onClick={handleSubmit}
                  className="form-cta-button__primary-btn"
                  type="submit"
                >
                  Next
                </button>
              )}
            </div>
            {ssoURL ? (
              <>
                <p className="text-center mt-4 mb-4">Or</p>
                <div
                  onClick={() => handleSSOLogin()}
                  className="cursor-pointer"
                >
                  <h6 className="text-center" style={{ color: "#276ef1" }}>
                    Sign in using single sign-on (SSO).
                  </h6>
                </div>
              </>
            ) : (
              ""
            )}
          </form>
        </div>
      </LoginPageLyout>
    </>
  );
};

export default LoginPage;
